import {
  FULL_PRODUCT_NOT_IN_ASSORTMENT,
  FULL_PRODUCT_STATUS_AVAILABLE,
  FULL_PRODUCT_STATUS_AVAILABLE_REPLACEMENT,
  FULL_PRODUCT_STATUS_CURRENTLY_NOT_AVAILABLE,
  FULL_PRODUCT_STATUS_DELIVERY_10,
  FULL_PRODUCT_STATUS_DELIVERY_20,
  FULL_PRODUCT_STATUS_DELIVERY_3,
  FULL_PRODUCT_STATUS_DELIVERY_5,
  FULL_PRODUCT_STATUS_DELIVERY_5_7,
  FULL_PRODUCT_STATUS_DELIVERY_7,
  FULL_PRODUCT_STATUS_GRATIS,
  FULL_PRODUCT_STATUS_NOT_AVAILABLE,
  FULL_PRODUCT_STATUS_NOT_IN_CATALOG,
  FULL_PRODUCT_STATUS_OUT_OF_TRADE,
  FULL_PRODUCT_STATUS_UNAVAILABLE,
  PRODUCT_STATUS_AV,
  PRODUCT_STATUS_AVAILABLE,
  PRODUCT_STATUS_GRATIS,
  PRODUCT_STATUS_NL,
} from 'shared/consts/stockStatus'

const STATUS_COLOR_MAP = {
  '': 'u-color--info-dark',
  green: 'u-color--positive',
  red: 'u-color--negative',
  default: 'u-color--info-dark',
}

const STATUS_BG_COLOR_MAP = {
  '': 'u-background-color--warning-dark',
  green: 'u-background-color--positive',
  red: 'u-background-color--negative',
  default: 'u-background-color--warning-dark',
}

// delivery{NUM} keys are legacy one for LMS
// new  key format is delivery.{NUM}
const REASONS = {
  'general.label.product.available': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'green',
    fullStatus: FULL_PRODUCT_STATUS_AVAILABLE,
  },
  'general.label.product.delivery3': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'green',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_3,
  },
  'general.label.product.delivery.3_5': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'green',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_3,
  },
  'general.label.product.delivery5': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_5,
  },
  'general.label.product.delivery.5': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'green',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_5,
  },
  'general.label.product.delivery.5_7': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_5_7,
  },
  'general.label.product.delivery7': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_7,
  },
  'general.label.product.delivery.7': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_7,
  },
  'general.label.product.delivery.7_10': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_7,
  },
  'general.label.product.delivery10': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_10,
  },
  'general.label.product.delivery.10': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_10,
  },
  'general.label.product.delivery.10_14': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_10,
  },
  'general.label.product.delivery.20_30': {
    status: PRODUCT_STATUS_AVAILABLE,
    statusColor: 'orange',
    fullStatus: FULL_PRODUCT_STATUS_DELIVERY_20,
  },
  'general.label.product.outOfTrade': {
    status: PRODUCT_STATUS_AV,
    statusColor: 'red',
    fullStatus: FULL_PRODUCT_STATUS_OUT_OF_TRADE,
  },
  'general.label.product.av': {
    status: PRODUCT_STATUS_AV,
    statusColor: 'red',
    fullStatus: FULL_PRODUCT_STATUS_OUT_OF_TRADE,
  },
  'general.label.product.currentlyNotAvailable': {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_CURRENTLY_NOT_AVAILABLE,
  },
  'general.label.product.notAvailable': {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_NOT_AVAILABLE,
  },
  'general.label.product.nl': {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_NOT_AVAILABLE,
  },
  'general.label.product.notInCatalog': {
    status: PRODUCT_STATUS_NL,
    statusColor: 'red',
    fullStatus: FULL_PRODUCT_STATUS_NOT_IN_CATALOG,
  },
  'general.label.product.unavailable': {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_UNAVAILABLE,
  },
  'general.label.product.availableReplacement': {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_AVAILABLE_REPLACEMENT,
  },
  'general.label.product.gratis': {
    status: PRODUCT_STATUS_GRATIS,
    statusColor: '',
    fullStatus: FULL_PRODUCT_STATUS_GRATIS,
  },
  'general.label.product.notInAssortment': {
    status: PRODUCT_STATUS_AV,
    statusColor: '',
    fullStatus: FULL_PRODUCT_NOT_IN_ASSORTMENT,
  },
  default: {
    status: PRODUCT_STATUS_NL,
    statusColor: '',
    fullStatus: '',
  },
}

export const getStatusColor = statusColor =>
  STATUS_COLOR_MAP[statusColor] || STATUS_COLOR_MAP.default

export const getStatusBgColor = statusColor =>
  STATUS_BG_COLOR_MAP[statusColor] || STATUS_BG_COLOR_MAP.default

export const getLabelByStatusReason = statusReason =>
  statusReason.replace('product.stockStatus', 'general.label.product')

export const getLabelByNotOnStockMessage = notOnStockMessage =>
  notOnStockMessage.replace('product.notOnStock', 'general.label.product')

export const getColorByStatusReason = statusReason =>
  (REASONS[getLabelByStatusReason(statusReason)] || REASONS.default).statusColor

export const getStatusByStatusReason = statusReason =>
  (REASONS[getLabelByStatusReason(statusReason)] || REASONS.default).status

export const getFullStatus = (statusReason, notOnStockMessage = null) => {
  if (notOnStockMessage) {
    const reason = REASONS[getLabelByNotOnStockMessage(notOnStockMessage)]

    if (reason) {
      return reason.fullStatus
    }
  }
  if (typeof REASONS[getLabelByStatusReason(statusReason)] !== 'undefined') {
    return REASONS[getLabelByStatusReason(statusReason)].fullStatus
  }

  return statusReason
}

// REBRANDING SECTION ---------------------------------------------------------

const STATUS_COLOR_MAP_REBRANDING = {
  '': 'u-color-rebranding--info-dark',
  green: 'u-color-rebranding--positive o-ProductStatus--positive',
  red: 'u-color-rebranding--negative',
  default: 'u-color-rebranding--info-dark',
}

export const getStatusColorRebranding = statusColor =>
  STATUS_COLOR_MAP_REBRANDING[statusColor] ||
  STATUS_COLOR_MAP_REBRANDING.default
